import React, { createContext, useContext, useState, useEffect } from 'react';
import { profileAPI } from '@/lib/api';
import { useAuth } from './AuthContext';

const EntitlementsContext = createContext(null);

export const useEntitlements = () => {
  const context = useContext(EntitlementsContext);
  if (!context) {
    throw new Error('useEntitlements must be used within EntitlementsProvider');
  }
  return context;
};

export const EntitlementsProvider = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const [entitlements, setEntitlements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isAuthenticated && user) {
      loadEntitlements();
    } else {
      setEntitlements([]);
      setLoading(false);
    }
  }, [isAuthenticated, user]);

  const loadEntitlements = async () => {
    setLoading(true);
    try {
      const response = await profileAPI.getEntitlements();
      setEntitlements(response.data);
    } catch (error) {
      console.error('Failed to load entitlements:', error);
      setEntitlements([]);
    } finally {
      setLoading(false);
    }
  };

  const refreshEntitlements = async () => {
    await loadEntitlements();
  };

  const hasEntitlement = (code) => {
    return entitlements.some((ent) => ent.code === code);
  };

  const isPareiActive = hasEntitlement('PAREI_AD');

  return (
    <EntitlementsContext.Provider
      value={{
        entitlements,
        loading,
        isPareiActive,
        hasEntitlement,
        refreshEntitlements,
      }}
    >
      {children}
    </EntitlementsContext.Provider>
  );
};
